<!--
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2023-09-12 15:51:38
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-09-26 17:24:26
 * @FilePath: \plantingSubsidy_web_update\src\views\statistics-charts\insurance-statistics\components\v1\PlantInsurance\index.vue
 * @Description: 承保一张- 各作物承保情况
-->

<template>
  <div style="height:calc(100% - 3rem);display: flex;">
    <div class="left">
      <insurance-area-proportion ref="areaProportionPage" />
    </div>
    <div class="right">
      <complete-radio-all ref="plantInsurancePage" />
      <div class="item_box">
        <div class="item item_left">
         完全成本
        </div>
        <div class="item item_right">
         物化成本
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import InsuranceAreaProportion from '../InsuranceAreaProportion'
import CompleteRadioAll from '../CompleteRadioAll'
export default {
  props: {
    year: {
      type: String,
      default: ''

    }
  },
  components: {
    CompleteRadioAll, InsuranceAreaProportion
  },
  data () {
    return {
      level: this.$store.state.account.user.level,
      account: this.$store.state.account,
      cityCode: ''

    }
  },
  created () {
    this.cityCode = this.account.userArea.city
    if (this.level <= 3) {
      // 各作物承保情况
      this.getPlantInsuranceLeft()
      this.getPlantInsuranceRight()
    }
  },
  methods: {
    /* 各作物承保情况 */
    getPlantInsuranceLeft () {
      this.$get('/statistics/statisticsBase/getInsuranceAcreageRatio', {
        // year: moment().format('YYYY'),
        year: this.year,
        province: this.account.user.province || '230000000000',
        city: this.cityCode || '',
        county: this.account.userArea.county || ''
      })
        .then(r => {
          let data = r.data.data
          let dataList = [
            // { value: 100, name: '水稻政策性保险' },
            //   { value: 200, name: '大豆政策性保险' },
            //   { value: 50, name: '玉米政策性保险' },
            //   { value: 80, name: '小麦政策性保险' }
          ]

          if (data && data.source.length > 0) {
            dataList = data.source.map(i => ({
              value: i.labelValue,
              name: i.type
            }))
          } else {
            dataList = [

            ]
          }

          this.$refs.areaProportionPage.dataList = [...dataList]
          // this.initData()
        })
        .catch(() => { })
    },

    getPlantInsuranceRight () {
      this.$get('/statistics/statisticsBase/getInsuranceCompleteRatioNew', {
        // year: moment().format('YYYY'),
        year: this.year,
        province: this.account.user.province || '230000000000',
        city: this.cityCode || '',
        county: this.account.userArea.county || ''
      })
        .then(r => {
          let data = r.data.data
          console.log('政策保险完成比例(%) 市:', data)
          if (data && data.dataset.length >= 0) {
            /* 水稻 */
            let dataList1 = [
              {
                value: Number((data.dataset[0].source[0].whAcreage / 10000).toFixed(2)),
                name: '物化成本'
              }, {
                value: Number((data.dataset[0].source[0].wqAcreage / 10000).toFixed(2)),
                name: '完全成本'
              }
              // {
              //   value: Number((data.dataset[0].source[0].srAcreage / 10000).toFixed(2)),
              //   name: '收入险'
              // }, {
              //   value: Number((data.dataset[0].source[0].jgAcreage / 10000).toFixed(2)),
              //   name: '价格险'
              // }

            ]
            let percent1 = (Number(data.dataset[0].source[0].labelValue) / Number(data.dataset[0].source[0].plantAcreage) * 100).toFixed(2)
            let chartData1 = {
              dataList: dataList1,
              percent: percent1

            }
            /* 玉米 */
            let dataList2 = [
              {
                value: Number((data.dataset[1].source[0].whAcreage / 10000).toFixed(2)),
                name: '物化成本'
              }, {
                value: Number((data.dataset[1].source[0].wqAcreage / 10000).toFixed(2)),
                name: '完全成本'
              }
              //  {
              //   value: Number((data.dataset[1].source[0].srAcreage / 10000).toFixed(2)),
              //   name: '收入险'
              // }, {
              //   value: Number((data.dataset[1].source[0].jgAcreage / 10000).toFixed(2)),
              //   name: '价格险'
              // }

            ]
            let percent2 = (Number(data.dataset[1].source[0].labelValue) / Number(data.dataset[1].source[0].plantAcreage) * 100).toFixed(2)
            let chartData2 = {
              dataList: dataList2,
              percent: percent2

            }

            /* 大豆 */
            let dataList3 = [
              {
                value: Number((data.dataset[2].source[0].whAcreage / 10000).toFixed(2)),
                name: '物化成本'
              }, {
                value: Number((data.dataset[2].source[0].wqAcreage / 10000).toFixed(2)),
                name: '完全成本'
              }
              // {
              //   value: Number((data.dataset[2].source[0].srAcreage / 10000).toFixed(2)),
              //   name: '收入险'
              // }, {
              //   value: Number((data.dataset[2].source[0].jgAcreage / 10000).toFixed(2)),
              //   name: '价格险'
              // }

            ]
            let percent3 = (Number(data.dataset[2].source[0].labelValue) / Number(data.dataset[2].source[0].plantAcreage) * 100).toFixed(2)
            let chartData3 = {
              dataList: dataList3,
              percent: percent3

            }
            /* 小麦 */
            let dataList4 = [
              {
                value: Number((data.dataset[3].source[0].whAcreage / 10000).toFixed(2)),
                name: '物化成本'
              }, {
                value: Number((data.dataset[3].source[0].wqAcreage / 10000).toFixed(2)),
                name: '完全成本'
              }
              // {
              //   value: Number((data.dataset[3].source[0].srAcreage / 10000).toFixed(2)),
              //   name: '收入险'
              // }, {
              //   value: Number((data.dataset[3].source[0].jgAcreage / 10000).toFixed(2)),
              //   name: '价格险'
              // }

            ]
            let percent4 = (Number(data.dataset[3].source[0].labelValue) / Number(data.dataset[3].source[0].plantAcreage) * 100).toFixed(2)
            if (data.dataset[3].source[0].plantAcreage === 0) percent4 = 0

            let chartData4 = {
              dataList: dataList4,
              percent: percent4

            }
            this.$refs.plantInsurancePage.initData({
              chartData1: chartData1,
              chartData2: chartData2,
              chartData3: chartData3,
              chartData4: chartData4

            }

            )
          }
          // this.setData(data)
        })
        .catch(() => { })
    },
    /* 设置作物策性保险 */
    setData (data) {
      // 左侧
      let chartDataLeft = {

        dataList: [{ value: 100, name: '水稻政策性保险' },
          { value: 200, name: '大豆政策性保险' },
          { value: 50, name: '玉米政策性保险' },
          { value: 80, name: '小麦政策性保险' }
        ]
      }
      this.$refs.areaProportionPage.dataList = [...chartDataLeft.dataList]
    }

  },
  watch: {
    year: {

      handler () {
        if (this.level <= 3) {
          this.getPlantInsuranceLeft()
          this.getPlantInsuranceRight()
        }
      }
    }

  }
}
</script>
<style scoped>
.left {
  width: 45%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}
.right {
  flex: 1;
  padding-top: 0.4rem;
  position: relative;
}
.item_box{
  color:#fff;
  display:flex;
  position: absolute;
  width: 100%;
  justify-content: center;
  bottom: -5px;
}
.item{
margin:10px;
font-size: 0.8rem;
color:#c4e0fa;
padding-left: 1.2rem;
position: relative;
}

.item::before{
  display: block;
  position: absolute;
  left: 0;
  top: 0.3rem;
  content:'';
  width: 10px;
  height: 10px;
  background: white;

}
.item_left::before{
  /* background: #27F3FA; */
  background: #27f57a;
}
.item_right::before{

  /* background: #F8AF30; */
  background: #faf447;

}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/components/v1/PlantInsurance/index.vue